import api from './authService';

export const opportunityService = {
  async republish(opportunityId: number) {
    const response = await api.put(`/opportunities/${opportunityId}/republish`);
    return response.data;
  },

  async deactivate(opportunityId: number) {
    const response = await api.put(`/opportunities/${opportunityId}/deactivate`);
    return response.data;
  },

  async activateIntegration(opportunityId: number) {
    const response = await api.put(`/opportunities/${opportunityId}/activate-integration`);
    return response.data;
  },

  async resendApplies(opportunityId: number, mode: 'all' | 'first_n' = 'all', limit?: number) {
    const response = await api.post(`/opportunities/${opportunityId}/resend-applies`, {
      mode,
      limit
    });
    return response.data;
  },

  async unpublish(opportunityId: number, reason: string, recruiterId: number, afterSales?: boolean) {
    const response = await api.put(`/opportunities/${opportunityId}/unpublish`, {
      reason,
      recruiter_id: recruiterId,
      after_sales: afterSales
    });
    return response.data;
  },

  async getUnpublishInfo(opportunityId: number) {
    const response = await api.get(`/opportunities/${opportunityId}/unpublish-info`);
    return response.data;
  },

  async getDeactivationInfo(opportunityId: number) {
    const response = await api.get(`/opportunities/${opportunityId}/deactivation-info`);
    return response.data;
  }
};
